import React from "react";
import { Card, CardActionArea, Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { keyframes } from "@mui/system";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const RestaurantCard = ({ restaurant, index = 0 }) => {
  return (
    <Card
      sx={{
        borderRadius: "16px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        opacity: 0,
        animation: `${fadeInUp} 0.6s ease-out forwards`,
        animationDelay: `${index * 0.15}s`,
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        },
      }}
    >
      <CardActionArea 
        onClick={() => window.location.href = "https://pide.mennu.mx/seven"}
      >
        <Box
          sx={{
            height: 180, // Uber Eats style banner height
            backgroundImage: `url(${restaurant.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Logo on top left */}
          {restaurant.logo && (
            <Box
              sx={{
                position: "absolute",
                top: 12,
                left: 12,
                width: 48,
                height: 48,
                borderRadius: "50%",
                backgroundColor: "white", // Ensure white background for logos with transparency
                backgroundImage: `url(${restaurant.logo})`,
                backgroundSize: "contain", // Change to contain so logos don't get cropped
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                zIndex: 3,
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                border: "2px solid white", // Optional: adds a nice clean border around the logo
              }}
            />
          )}

          {/* Dark Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.55)", // Made darker from 0.35
              zIndex: 1,
              borderRadius: "inherit",
            }}
          />

          {/* Content */}
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              px: 2,
            }}
          >
            <Typography
              component="div"
              sx={{
                color: "white",
                fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                fontWeight: "bold",
                fontStyle: "normal",
                fontSize: "28px", // Increased size
                lineHeight: "36px", // Increased line height to match
                textAlign: "center",
                letterSpacing: "0.5px",
                mb: 0.5,
              }}
            >
              {restaurant.name}
            </Typography>

            {/* Hours and Location */}
            {restaurant.hours && restaurant.location && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mt: 0.5,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#fef751",
                    color: "#1a1a1a",
                    padding: "2px 8px 2px 4px",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: "0.9rem" }} />
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "0.75rem",
                      fontWeight: "bold",
                      fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                    }}
                  >
                    {restaurant.location}
                  </Typography>
                </Box>
                <Typography
                  component="span"
                  sx={{
                    color: "#e0e0e0",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    fontFamily: '"Proxima Nova", Helvetica, Arial, sans-serif',
                  }}
                >
                  {restaurant.hours}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default RestaurantCard;
